import { useEffect, useState } from "react";
import { ArrowUp, MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/site-data";

export default function FloatingActions() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div className="fixed right-4 sm:right-6 bottom-6 z-40 flex flex-col items-end gap-3">
      <a
        href={`https://wa.me/${COMPANY.whatsapp}?text=Hello%20Agroya%20Refinery%2C%20I%20have%20an%20enquiry.`}
        target="_blank" rel="noreferrer"
        data-testid="whatsapp-float"
        className="w-13 h-13 sm:w-14 sm:h-14 rounded-full bg-[#25D366] hover:bg-[#1DAE53] flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.35)] transition-colors"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6 text-white" strokeWidth={1.8} />
      </a>
      {show && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="back-to-top"
          className="w-11 h-11 rounded-full bg-white border border-[#E5E5E5] hover:border-[#D4AF37] flex items-center justify-center shadow-md transition-all"
          aria-label="Back to top"
        >
          <ArrowUp className="w-4 h-4 text-[#0A0A0A]" strokeWidth={1.8} />
        </button>
      )}
    </div>
  );
}
